import type { Theme } from '@mui/material/styles';

// Claro: branco liso (o degradê cinza deixava a página com cara de suja). Escuro: termina no fundo padrão, senão o card some nele
export function fundoNeutro(tema: Theme): string {
  if (tema.palette.mode !== 'dark') return tema.palette.background.paper;
  return `linear-gradient(180deg, #26343f 0, ${tema.palette.background.default} 640px)`;
}

// Espelho do fundo do topo: no claro não escurece (página é branca); no escuro funde com a página e escurece no pé
export function fundoRodape(tema: Theme): string {
  if (tema.palette.mode !== 'dark') return 'transparent';
  return 'linear-gradient(180deg, transparent 0, #141c22 100%)';
}
